import { createFileRoute } from '@tanstack/react-router'
import PageHeader from '@/components/settings/PageHeader'
import { Button } from '@/components/shared/atoms/Button'

export const Route = createFileRoute('/settings/subscriptions/price')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SubscriptionPricePage />
}

const SubscriptionPricePage = () => {
    return (
        <div className="min-h-dvh bg-white px-2 pb-14">
            <PageHeader title="Subscription price" />
            <div className="mt-4">
                <div className="border-black-6 mb-6 rounded-2xl border px-3 py-4">
                    <div className="mb-2 flex items-center justify-between">
                        <span className="text-base font-medium">Annualy</span>
                        <span className="text-base text-blue-600">
                            Average of all creators: $105
                        </span>
                    </div>
                    <div className="border-black-12 flex items-center rounded-xl border px-4 py-3">
                        <span className="mr-2 text-base">$</span>
                        <input
                            type="text"
                            placeholder="Enter price"
                            className="flex-grow bg-transparent text-base outline-none"
                        />
                        <span className="text-black-48 text-sm">
                            $ 0 / per month
                        </span>
                    </div>
                </div>

                <div className="border-black-6 mb-6 rounded-2xl border px-3 py-4">
                    <div className="mb-2 flex items-center justify-between">
                        <span className="text-base font-medium">Monthly</span>
                        <span className="text-base text-blue-600">
                            Average of all creators: $15
                        </span>
                    </div>
                    <div className="border-black-12 flex items-center rounded-xl border px-4 py-3">
                        <span className="mr-2 text-base">$</span>
                        <input
                            type="text"
                            placeholder="Enter price"
                            className="flex-grow bg-transparent text-base outline-none"
                        />
                    </div>
                </div>

                <p className="text-14 text-black-48 mb-20">
                    *any changes to subscription prices will
                    <br />
                    apply to new subscribers only
                </p>

                <div className="fixed right-0 bottom-0 left-0 mx-auto max-w-md p-2 md:max-w-4xl">
                    <Button variant="solid" className="w-full">
                        <span className="mr-2">✓</span>
                        Save
                    </Button>
                </div>
            </div>
        </div>
    )
}
